import { pedidoService } from '@/services/pedidoService';
import router from '../../router'
import Pedido from '@/domain/Pedido';

const getDefaultState = () => {
  return {
    pedidos: [],
    selected: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  pedidos: state => state.pedidos,
  pedidosSelected: state => state.selected,
  isPedidosModified: state => !!state.isModified
};

const actions = {
  async sendPedidosAPI({ commit, dispatch }, pedidos) {
    if (pedidos.length) {
      for (const pedido of pedidos) {
        await dispatch('sendPedidoAPI', pedido);
      }
      commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' });
    }
  },
  async sendPedidoAPI({ commit }, pedido) {
    if (pedido.status.startsWith('A') && pedido.versao_imp !== undefined) {
      try {
        const response = await pedidoService.sendPedidoAPI(pedido);
        pedido.id_saida = Number(process.env.NODE_ENV === 'production' ? response.data.result.id_saida : response.data.id_saida);
        delete pedido.versao_imp;
        await pedidoService.updatePedido(pedido);
        commit('UPDATE_PEDIDO', pedido);
        commit('SET_IS_PEDIDOS_MODIFIED', true);
      } catch (error) {
        console.log(error);
        commit('SHOW_SNACKBAR', { text: error, status: 'error' });
      }
    }
  },
  async fetchPedidos({ commit }) {
    try {
      const response = await pedidoService.getPedidos();
      commit('SET_PEDIDOS', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchPedidosAPI({ commit }) {
    try {
      const response = await pedidoService.getPedidosAPI();
      commit('SET_PEDIDOS', response);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchPedidoItensAPI({ commit }, pedido) {
    try {
      const response = await pedidoService.getPedidoItensAPI(pedido.id_saida);
      const itens = process.env.NODE_ENV === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
      pedido.itens = itens && itens.length ? itens : [];
      await pedidoService.updatePedido(pedido);
      commit('UPDATE_PEDIDO', pedido);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchPedidoParcelasAPI({ commit }, pedido) {
    try {
      const response = await pedidoService.getPedidoParcelasAPI(pedido.id_saida);
      const parcelas = process.env.NODE_ENV === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
      pedido.parcelas = parcelas && parcelas.length ? parcelas : [];
      await pedidoService.updatePedido(pedido);
      commit('UPDATE_PEDIDO', pedido);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async gerarPedido({ commit, dispatch }, pedido) {
    try {
      if (!pedido.id_cliente) {
        const { id_cliente } = await dispatch('sendClienteByIdAPI', pedido.id_cliente_interno);
        pedido.id_cliente = id_cliente;
      }

      const updPedido = await pedidoService.generatePedido(pedido);
      commit('UPDATE_PEDIDO', updPedido);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: 'Não foi possível gerar o pedido!', status: 'error' });
    }
  },
  async gerarPedidos({ commit, dispatch }, pedidos) {
    if (pedidos.length) {
      for (const pedido of pedidos) {
        await dispatch('gerarPedido', pedido);
      }
      commit('SET_PEDIDOS_SELECTED', []);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
      commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' });
    }
  },
  async createPedido({ commit }, { idColaborador, idEmpresa }) {
    const pedido = new Pedido();
    pedido.id_colaborador = +idColaborador;
    pedido.id_empresa = +idEmpresa;
    try {
      const id = await pedidoService.addPedido(pedido);
      pedido.id_interno = id;
      commit('SET_PEDIDO', pedido);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
      router.push({ name: 'Pedido', params: { id: pedido.id_interno }});
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async updatePedido({ commit }, updPedido) {
    await pedidoService.updatePedido(updPedido);
    commit('UPDATE_PEDIDO', updPedido);
    commit('SET_IS_PEDIDOS_MODIFIED', true);
  },
  async deletePedido({ commit }, id) {
    try {
      await pedidoService.deletePedido(id);
      commit('DELETE_PEDIDO', id);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
      // router.push({ name: 'Home' });
      commit('SHOW_SNACKBAR', { text: 'Registro excluído com sucesso.', status: 'success' });
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async deletePedidos({ commit, dispatch }, pedidos) {
    if (confirm(`Deseja excluir ${pedidos.length} registros?`)) {
      for (const pedido of pedidos) {
        await dispatch('deletePedidoSilent', pedido.id_interno);
      }
      commit('SET_PEDIDOS_SELECTED', []);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
      // commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' });
    } else {
      return;
    }
  },
  async deletePedidoSilent({ commit }, id) {
    try {
      await pedidoService.deletePedido(id);
      commit('DELETE_PEDIDO', id);
      commit('SET_IS_PEDIDOS_MODIFIED', true);
      // router.push({ name: 'Home' });
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  selectAllPedidos({ state, commit }) {
    commit('SET_PEDIDOS_SELECTED', state.pedidos);
  },
  clearPedidosSelected({ commit }) {
    commit('SET_PEDIDOS_SELECTED', []);
  }
};

const mutations = {
  CLEAR_PEDIDOS_STATE: state => Object.assign(state, getDefaultState()),
  SET_PEDIDOS: (state, pedidos) => state.pedidos = pedidos,
  SET_PEDIDO: (state, pedido) => state.pedidos.push(pedido),
  SET_PEDIDOS_SELECTED: (state, selected) => state.selected = selected,
  UPDATE_PEDIDO: (state, updPedido) => {
    const index = state.pedidos.findIndex(pedido => pedido.id_interno === updPedido.id_interno);
    if (index !== -1) state.pedidos.splice(index, 1, updPedido);
  },
  DELETE_PEDIDO: (state, id) => state.pedidos = state.pedidos.filter(pedido => pedido.id_interno !== id),
  SET_IS_PEDIDOS_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}